/** Keep in sync with BCN-backend/models/authPageContent/limits.js */
const STRING = max => ({ max })
const MULTILINE = (perLine, maxLines) => ({ perLine, maxLines, max: perLine * maxLines + Math.max(0, maxLines - 1) })

export const LIMITS = {
  desktop: {
    heading: MULTILINE(40, 2),
    benefitsList: MULTILINE(55, 6),
    benefitItem: STRING(55),
    benefitsMax: 6,
    illustrationLabel: STRING(22),
    illustrationsCount: 3,
    pulseLabel: STRING(35),
    pulseCount: STRING(40),
    pulseSub: STRING(80)
  },
  stage1: {
    exploreButton: STRING(45),
    trustBadgeIcon: STRING(30),
    trustBadgeLabel: STRING(22),
    trustBadgesCount: 3,
    slidesCount: 3,
    slideBadge: STRING(25),
    slideHeading: MULTILINE(35, 2),
    slideFeature: STRING(30),
    slideDescription: STRING(120),
    slideCta: MULTILINE(45, 2)
  },
  stage2: {
    heroTitle: MULTILINE(35, 3),
    heroSub: STRING(100),
    formTitle: STRING(50),
    mapTooltip: STRING(55),
    heroStatIcon: STRING(30),
    heroStatValue: STRING(12),
    heroStatLabel: STRING(22),
    heroStatsCount: 2,
    liveFeedCity: STRING(20),
    liveFeedState: STRING(5),
    liveFeedTime: STRING(12),
    liveFeedCount: 3,
    footerPrefix: STRING(35),
    footerLinkText: STRING(25)
  },
  images: {
    desktopIllustration: 'Landscape 3:2 — recommended 600×400px',
    mobileSlide: 'Portrait 4:5 — recommended 480×600px (Slide 1: community photo)',
    map: 'Square graphic — max 400×400px, PNG preferred'
  }
}

export const clampField = (value, spec) => {
  if (!spec) return value
  const str = typeof value === 'string' ? value : ''
  if (spec.perLine != null) {
    return str.split('\n').slice(0, spec.maxLines).map(l => l.slice(0, spec.perLine)).join('\n')
  }
  return str.slice(0, spec.max)
}

export const limitHint = spec => {
  if (!spec) return ''
  if (spec.perLine != null) return `Max ${spec.maxLines} lines, ${spec.perLine} chars per line`
  return `Max ${spec.max} characters`
}
